export default __webpack_public_path__ + "static/media/miscellaneous09.8cf7b15d.png";